import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotTopicsSection from './components/HotTopicsSection';
import ChannelMatrix from './components/ChannelMatrix';
import ExclusiveSection from './components/ExclusiveSection';
import CTASection from './components/CTASection';
import { categories } from '@/mocks/news';

export default function Home() {
  const siteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '每日大赛黑料网',
    url: 'https://www.meiridasaiheiliaowang.com',
    description: '每日大赛黑料网 —— 网红大瓜实时追踪，黑料每日更新，吃瓜爆料第一手。聚合每日大赛黑料最新爆料、网红塌房现场、博主反差视频等一手资讯。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.meiridasaiheiliaowang.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '每日大赛黑料网',
    url: 'https://www.meiridasaiheiliaowang.com',
    description: '国内领先的网红娱乐圈爆料资讯平台，致力于为广大网友提供最新、最全、最真实的一手爆料内容。',
    foundingDate: '2023',
    email: 'tips@meiridasaiheiliaowang.com',
    sameAs: [
      'https://weibo.com',
      'https://www.douyin.com',
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://www.meiridasaiheiliaowang.com',
      },
    ],
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '每日大赛黑料网是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '每日大赛黑料网是国内领先的网红娱乐圈爆料资讯平台，致力于为广大网友提供最新、最全、最真实的一手爆料内容，涵盖网红塌房、反差视频、八卦内幕、私生活揭秘等热门话题。',
        },
      },
      {
        '@type': 'Question',
        name: '每日大赛黑料网的爆料信息可靠吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们坚持以事实为依据，所有爆料均经过多方交叉验证后才予以发布。编辑团队由资深娱乐记者和行业内部人士组成，确保每一条信息的真实性和准确性。',
        },
      },
    ],
  };

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotTopicsSection />
        <ChannelMatrix />
        <ExclusiveSection />
        <CTASection />
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(siteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
    </>
  );
}